import {Observable} from "rxjs";
import {CustomTag} from "../custom-tag";

export abstract class CustomTagsGateway {
  abstract create(tag: CustomTag): Observable<CustomTag>

  abstract list(params: { companiesId: Array<string> }): Observable<CustomTag[]>

  abstract update(tag: CustomTag): Observable<CustomTag>

  abstract remove(id: number): Observable<void>

  abstract find(id: number): Observable<CustomTag>
}
